export default __webpack_public_path__ + "static/media/048-baker.00fd68df.svg";